export default "__VITE_ASSET__DsJCREE4__"